import React from 'react';
import TextField from '@mui/material/TextField';
import validateCuit from '../../utils/validateCuit';
import servicePUC5 from "../../services/delfos";
import serviceOrders from "../../services/orders";
import Tooltip from '@mui/material/Tooltip';
import constants from '../../utils/constants';
import { ThemeProvider } from '@mui/material/styles';

const index = ({ maxWidth, className, mode, entityDocId, mandatory, maxLength, itemFunction, disabled, id, name, value, onChange, onBlur, user, instance, help, onLoadingChange, error, errorHelpText, onValidationField, email, cuit, type, design, onFocus, heightParam, widthParam, minWidthParam }) => {

  const handleChange = (event) => {
    if (onChange) {
      onValidationField(false, '', id)
      onChange(event);
      if (mandatory && !event.target.value) {
        onValidationField(true, 'El campo es obligatorio', id)
      } else {
        onValidationField(false, '', id)
      }
    }
  };

  const handleFocus = (event, newValue) => {
    if (onFocus) {
      onFocus(event, newValue);
    }
  };


  const onValidateCuit = (e) => {

    let cuit = e.target.value;

    onValidationField(false, '', id)
    if (cuit) {
      onLoadingChange(true);
      if (validateCuit(cuit)) {
        onValidationField(false, '', id)
      } else {
        onValidationField(true, 'CUIT/CUIL Incorrecto', id)
      }

      let requestAFIP = {
        "idPersona": cuit,
        "cuit": "30697956200"
      }

      if (entityDocId === '1') {
        servicePUC5.consultar(requestAFIP).then(
          (responsePUC) => {
            serviceOrders.getOrder(user, instance, cuit).then((responseORDER) => {
              onBlur(responsePUC, responseORDER, null, id);
              onLoadingChange(false);
            })
          },
          (error) => {
            console.log(error)
            onLoadingChange(false);
          }
        )
      } else {
        servicePUC5.consultar(requestAFIP).then(
          (responsePUC) => {

            onBlur(responsePUC, null, null, id);
            onLoadingChange(false);
          },
          (error) => {
            console.log(error)
            onLoadingChange(false);
          }
        )
      }

      /*if (entityDocId === '1') {
        serviceOrders.findOwner(`${instance}.whoView`, cuit).then(
          (responseOwner) => {
            if (responseOwner.data === false) {
              servicePUC5.consultar(requestAFIP).then(
                (responsePUC) => {
                  serviceOrders.getOrder(user, instance, cuit).then((responseORDER) => {
                    uifsro.viewuifsro(cuit).then((responseuifsro) => {
                      onBlur(responsePUC, responseORDER, responseuifsro, id);
                      onLoadingChange(false);
                    }, (error) => {
                      console.log(error)
                      onBlur(responsePUC, responseORDER, null, id);
                      onLoadingChange(false);
                    })
                    onBlur(responsePUC, responseORDER, null, id);
                    onLoadingChange(false);
                  })
                },
                (error) => {
                  console.log(error)
                  onLoadingChange(false);
                }
              )
            } else {
              onValidationField(true, 'Ya existe Cuenta Comitente para el CUIT ingresado', id)
            }
          },
          (error) => {
            console.log(error)
            onLoadingChange(false);
          }
        )
      } else {
        servicePUC5.consultar(requestAFIP).then(
          (responsePUC) => {
            uifsro.viewuifsro(cuit).then((responseuifsro) => {
              onBlur(responsePUC, null, responseuifsro, id);
              onLoadingChange(false);
            })
            onBlur(responsePUC, null, null, id);
            onLoadingChange(false);
          },
          (error) => {
            console.log(error)
            onLoadingChange(false);
          }
        )
      }*/
    }
  }

  const validarOrden = (e) => {
    let orden = e.target.value;
    onLoadingChange(true);
    serviceOrders.getOrderId(user, instance, orden).then((responseORDER) => {
      onValidationField(false, '', id)

      if (!responseORDER.data) {
        onValidationField(true, 'La órden ingresada no existe, ingrese nuevamente', id)

      } else {
        let status = true;
        let validateEmail = true;
        let validateCuit = true;

        responseORDER.data.order.forEach((itemOrder) => {


          if (responseORDER.data.argTin === cuit) {
            validateCuit = false;
          }

          itemOrder.boxes.forEach((itemBoxes) => {
            itemBoxes.fields.forEach((itemFields) => {
              if (itemFields.idFieldTable === 'status' && (itemFields.value.toString().toUpperCase() === 'EN CURSO' || itemFields.value === null)) {
                status = false;
              }
              if (itemFields.idFieldTable === 'email' && Number(itemOrder.entityDocId) === 1 && itemFields.value === email) {
                validateEmail = false;
              }
            })
          })
        })


        if (validateEmail === true) {
          onValidationField(true, 'La órden ingresada no existe, ingrese nuevamente', id)
        } else {
          if (validateCuit === true) {
            onValidationField(true, 'La órden ingresada no existe, ingrese nuevamente', id)
          } else {
            if (status === true) {
              onValidationField(true, 'La órden ingresada se encuentra enviada para su aprobación', id)
            } else {
              onBlur(null, responseORDER, null, id);
            }
          }
        }

      }
      onLoadingChange(false);
    }).catch((error) => {
      console.log(error);
      onLoadingChange(false);
    });
  }

  //const inputWidth = value ? (value.length > name.length ? `${value.length * 7 - 2}px` : `${name.length * 6.25}px`) : "0px";
  //const minWidth = name.length + "ch";
  const inputWidth = value ? `${value.length}ch` : '0ch';
  const minWidth = name.length + "ch";
  const maxWidthParameter = maxWidth;
  return (
    <ThemeProvider theme={constants.CUSTOM_MUI_TEXT_FIELD_THEME}>
      <Tooltip title={help} placement="top">
        <TextField
          inputProps={{ maxLength: maxLength, readOnly: mode, style: { height: heightParam !== null ? heightParam : '1px', maxWidth: maxWidthParameter, width: widthParam !== null ? widthParam : inputWidth, minWidth: minWidthParam !== null ? minWidthParam : minWidth, fontSize: "inherit", fontWeight: '600', lineHeight: "inherit", paddingRight: "0px", paddingLeft: "8px" }, }}
          InputLabelProps={{
            style: { fontSize: "inherit", fontWeight: '600', lineHeight: "inherit", marginTop: !value ? '-8px' : '' }
          }}
          onFocus={(event, newValue) => handleFocus(event, newValue)}
          disabled={disabled}
          key={id}
          id={id}
          label={design !== 'table' ? <span>
            {name}
            {mandatory ? <span style={{ color: 'red' }}> *</span> : ''}
          </span> : null}
          variant="outlined"
          value={value}
          onChange={handleChange}
          onBlur={itemFunction === 'validateCuit' ? onValidateCuit :
            (itemFunction === 'validateOrder' ? validarOrden : null)}
          error={error}
          helperText={errorHelpText}
          required={mandatory}
          className={className ?? undefined}
          fullWidth
          email={email !== null && email !== undefined && email ? 'true' : 'false'}
          type={type}
        />
      </Tooltip>
    </ThemeProvider>
  )
}

export default index